import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const chatSlice = createSlice({
  name: "chat",
  initialState: {
    allUser: [],
    chatList: [],
    selectedChat: null,
    allMessage: [],
    status: "",
    error: null,
  },
  reducers: {
    setAllUser: (state, action) => {
      state.allUser = action.payload;
    },
    setChatList: (state, action) => {
      state.chatList = action.payload;
    },
    setAllMessage: (state, action) => {
      state.allMessage = action.payload;
    },
    setSelectedChat: (state, action) => {
      state.selectedChat = action.payload;
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  setAllUser,
  setChatList,
  setAllMessage,
  setSelectedChat,
  setStatus,
  setError,
} = chatSlice.actions;

export default chatSlice.reducer;
